import template from './inquiries-trashbin-header.pug';

export const InquiriesTrashbinHeaderComponent = {
  template,
  bindings: {
    records: '<',
    checkedIds: '<',
    totalPages: '<',
    totalCount: '<',
    page: '<',
    afterPageChange: '&',
    onFilterChange: '&',
    afterRecover: '&',
  },
  controller: class InquiriesTrashbinHeaderComponent {
    constructor(Inquiry, $log, $async) {
      'ngInject';
      this.Inquiry = Inquiry;
      this.$log = $log;
      this.recoverAll = $async(this.recoverAll.bind(this));
    }

    $onInit() {
    }

    async recoverAll() {
      try {
        await this.Inquiry.recoverModal(this.checkedIds);
        this.afterRecover({ $event: true });
      } catch (e) {
        this.$log.error(e);
      }
    }


    applyFilter(filter) {
      this.onFilterChange({ $event: { filter } });
    }

    applyPage({ page }) {
      this.afterPageChange({ $event: { page } });
    }
  }

};
